import { render } from "./RouteInfo.vue?vue&type=template&id=27fba1be&scoped=true"
import script from "./RouteInfo.vue?vue&type=script&lang=js"
export * from "./RouteInfo.vue?vue&type=script&lang=js"

import "./RouteInfo.vue?vue&type=style&index=0&id=27fba1be&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fba1be"]])

export default __exports__